module.exports = __webpack_public_path__ + "static/media/logo-color-h.d27d1c1b.svg";